import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, ListGroup, Button } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "../../../../layout/default";
import { useNavigate, useParams } from "react-router-dom";

const UserDetailList = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Fetch user list to display
    const fetchUserList = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        if (!authToken) {
          navigate("/shop/auths/login", { replace: true });
          return;
        }

        const response = await axios.get(`${process.env.REACT_APP_HOST}api/getUserdetails`, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        // Debug the response to check the data structure
        console.log("API Response:", response.data);
        debugger;

        // Check if the response contains 'data' and set users
        const userData = response.data.data ? [response.data.data] : [];

        console.log("Users data to set:", userData); // Check the structure of the data before setting

        setUsers(userData); // Ensures users is always an array
      } catch (error) {
        console.error("Error fetching user list:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to load user list.",
        });
      }
    };

    fetchUserList();
  }, [navigate]);

  const maskValue = (value) => {
    if (value.length === 12) {
      return value.replace(/(\d{4})(\d{4})(\d{4})/, "$1-****-****");
    } else if (value.length === 10) {
      return value.replace(/(\d{4})(\d{3})(\d{3})/, "$1-***-***");
    }
    return value;
  };

  const handleViewUser = (userId) => {
    navigate(`/shop/user-details/${userId}`);
  };

  const handleEditUser = (userId) => {
    navigate(`/shop/auths/update-user-details/${userId}`);
  }

  return (
    <Layout title="User List">
      <Container className="mt-4">
        <Row className="justify-content-md-center">
          <Col md={8}>
            <h3>User List</h3>
            {users.length ==0 ? (
              <p>No users found.</p>
            ) : (
              users.map((user) => (
                <Card className="mb-3" key={user.id}>
                  <Card.Body>
                    <ListGroup variant="flush">
                      <ListGroup.Item>
                        <strong>First Name:</strong> {user.first_name}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Last Name:</strong> {user.last_name}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Middle Name:</strong> {user.middle_name || "N/A"}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Phone Number 1:</strong> {user.phone_1}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>Phone Number 2:</strong> {user.phone_2 || "N/A"}
                      </ListGroup.Item>
                      {/* Render email if available */}
                      {user.email && (
                        <ListGroup.Item>
                          <strong>Email:</strong> {user.email}
                        </ListGroup.Item>
                      )}
                      {/* Aadhar Number - Ensure that you extract the data */}
                      <ListGroup.Item>
                        <strong>Aadhar Number:</strong>{" "}
                        {user.aadhar_number?.data ? maskValue(user.aadhar_number.data) : "N/A"}
                      </ListGroup.Item>
                      <ListGroup.Item>
                        <strong>PAN Card Number:</strong> {maskValue(user.pancard_number)}
                      </ListGroup.Item>
                    </ListGroup>
                    {/* <Button variant="primary" onClick={() => handleViewUser(user.id)}>
                      View Details
                    </Button> */}
                    <Button variant="primary" onClick={() => handleEditUser(user.id)}>
                      Edit
                    </Button>
                  </Card.Body>
                </Card>
              ))
            )}
          </Col>
        </Row>
      </Container>
    </Layout>
  );
};

export default UserDetailList;
